import _regeneratorRuntime from "/root/app/node_modules/@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(adsSaga),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(adsListener),
    _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(saveOfferDetailsSaga),
    _marked4 = /*#__PURE__*/_regeneratorRuntime.mark(adDetailsSaga),
    _marked5 = /*#__PURE__*/_regeneratorRuntime.mark(adDetailsListener),
    _marked6 = /*#__PURE__*/_regeneratorRuntime.mark(adPhotosSaga),
    _marked7 = /*#__PURE__*/_regeneratorRuntime.mark(accountAdPhotoUploadSaga),
    _marked8 = /*#__PURE__*/_regeneratorRuntime.mark(accountAdPhotoDeleteSaga),
    _marked9 = /*#__PURE__*/_regeneratorRuntime.mark(adPhotosListener),
    _marked10 = /*#__PURE__*/_regeneratorRuntime.mark(adStatsSaga),
    _marked11 = /*#__PURE__*/_regeneratorRuntime.mark(disableAdSaga),
    _marked12 = /*#__PURE__*/_regeneratorRuntime.mark(adStatsListener),
    _marked13 = /*#__PURE__*/_regeneratorRuntime.mark(universalOffersSaga),
    _marked14 = /*#__PURE__*/_regeneratorRuntime.mark(disableUniversalOfferSage),
    _marked15 = /*#__PURE__*/_regeneratorRuntime.mark(universalOffersListener);

import formatISO from 'date-fns/formatISO';
import { call, put, take, takeLatest, race, select } from 'redux-saga/effects';
import createRequestSaga from '@signal/utils/createRequestSaga';
import { FetchError } from '@signal/utils/errors';
import generateGuid from '@signal/utils/generateGuid';
import dataURItoBlob from '@signal/utils/dataURItoBlob';
import parseDate from '@signal/utils/parseDate';
import api from '../api';
import { withAudienceMicroserviceUrl, withNativeMicroserviceUrl } from '../api/utils';
import { activeAccountIdSelector } from '../auth';
import { adsLoad, adDetailsLoad, adDisableActions, adDisableLoad, adDisableSuccess, adsActions, adDetailsActions, adCreateActions, adPhotosActions, accountAdPhotosActions, accountAdPhotoUploadActions, accountAdPhotoUpload, accountAdPhotoDeleteActions, adPhotosLoad, adStatsActions, saveOfferDetails, universalOffersActions, universalOffersLoad, universalOfferDisableActions, universalOfferDisableLoad, universalOfferDisableSuccess } from './actions';
import { adListLoadedSelector, adListLoadingSelector, adDetailsLoadedSelector, adDetailsLoadingSelector, adDetailsIdParamSelector, adPhotosLoadedSelector, adPhotosLoadingSelector, adStatsLoadedSelector, adStatsLoadingSelector, universalOffersListIsLoadedSelector, universalOffersListIsLoadingSelector } from './selectors';
import { getFormErrors, endDateDataReducer } from './utils';
/**
 * Ads List Sagas
 */

/**
 * Ads request saga.
 * @type {createRequestSaga~requestSaga}
 */

export var loadAds = createRequestSaga(adsActions, {
  loadedSelector: adListLoadedSelector,
  loadingSelector: adListLoadingSelector
}, {
  forceRefresh: true
});
/**
 * Ads saga. Fetches ads from the API and dispatches either success or
 * failure depending on the result.
 * @return {Generator}
 */

export function adsSaga() {
  var activeAccountId;
  return _regeneratorRuntime.wrap(function adsSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return select(activeAccountIdSelector);

        case 2:
          activeAccountId = _context.sent;
          _context.next = 5;
          return put(api.get(adsActions, withAudienceMicroserviceUrl("/outputs/".concat(activeAccountId)), {}, {
            success: endDateDataReducer
          }));

        case 5:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
/**
 * Ads listener saga.
 * @return {Generator}
 */

export function adsListener() {
  return _regeneratorRuntime.wrap(function adsListener$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return takeLatest(adsLoad.getType(), adsSaga);

        case 2:
          _context3.next = 4;
          return takeLatest(adDisableLoad.getType(), disableAdSaga);

        case 4:
          _context3.next = 6;
          return takeLatest(adDisableSuccess.getType(), /*#__PURE__*/_regeneratorRuntime.mark(function disableAdSuccessSaga() {
            return _regeneratorRuntime.wrap(function disableAdSuccessSaga$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.next = 2;
                    return put(adsLoad());

                  case 2:
                  case "end":
                    return _context2.stop();
                }
              }
            }, disableAdSuccessSaga);
          }));

        case 6:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked2);
}
/**
 * Ad Details Sagas
 */

/**
 * Creates a new ad and dispatches either a success or failure action.
 * @return {Generator}
 */

export function saveOfferDetailsSaga(_ref) {
  var offerDetails, _ref$meta, offerId, isUniversal, setErrors, setSubmitting, activeAccountId, offersServiceUrl, _yield$race, failure, _failure$payload$resp, data, status, formErrors;

  return _regeneratorRuntime.wrap(function saveOfferDetailsSaga$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          offerDetails = _ref.payload, _ref$meta = _ref.meta, offerId = _ref$meta.offerId, isUniversal = _ref$meta.isUniversal, setErrors = _ref$meta.setErrors, setSubmitting = _ref$meta.setSubmitting;
          _context4.next = 3;
          return select(activeAccountIdSelector);

        case 3:
          activeAccountId = _context4.sent;
          offersServiceUrl = isUniversal ? withNativeMicroserviceUrl("/global-offers/".concat(activeAccountId)) : withAudienceMicroserviceUrl("/outputs/".concat(activeAccountId));
          _context4.next = 7;
          return put(api.post(adCreateActions, offersServiceUrl, {
            // If `adId` exists, add to payload so that it patches the existing ad rather
            // than creating a new one
            body: Object.assign({}, offerDetails, offerId && {
              id: offerId
            })
          }));

        case 7:
          _context4.next = 9;
          return race({
            success: take(adCreateActions.success),
            failure: take(adCreateActions.failure)
          });

        case 9:
          _yield$race = _context4.sent;
          failure = _yield$race.failure;

          if (!(failure && failure.payload instanceof FetchError)) {
            _context4.next = 23;
            break;
          }

          _failure$payload$resp = failure.payload.response, data = _failure$payload$resp.data, status = _failure$payload$resp.status;

          if (!(status !== 400)) {
            _context4.next = 15;
            break;
          }

          return _context4.abrupt("return");

        case 15:
          _context4.next = 17;
          return call(getFormErrors, data);

        case 17:
          formErrors = _context4.sent;

          if (!formErrors) {
            _context4.next = 23;
            break;
          }

          _context4.next = 21;
          return call(setErrors, formErrors);

        case 21:
          _context4.next = 23;
          return call(setSubmitting, false);

        case 23:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked3);
}
/**
 * Saga for the ad details page; loads the details for the `adId` route param.
 * @return {Generator}
 */

export function adDetailsSaga(_ref2) {
  var props, activeAccountId, adId, adDetailsServiceUrl;
  return _regeneratorRuntime.wrap(function adDetailsSaga$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          props = _ref2.payload;
          _context5.next = 3;
          return select(activeAccountIdSelector);

        case 3:
          activeAccountId = _context5.sent;
          _context5.next = 6;
          return select(adDetailsIdParamSelector, props);

        case 6:
          adId = _context5.sent;

          if (adId) {
            _context5.next = 11;
            break;
          }

          _context5.next = 10;
          return put(adDetailsActions.success());

        case 10:
          return _context5.abrupt("return", _context5.sent);

        case 11:
          // Otherwise we fetch the ad details
          adDetailsServiceUrl = props.isUniversal ? withNativeMicroserviceUrl("/global-offers/".concat(activeAccountId, "/").concat(adId)) : withAudienceMicroserviceUrl("/outputs/".concat(activeAccountId, "/").concat(adId));
          _context5.next = 14;
          return put(api.get(adDetailsActions, adDetailsServiceUrl));

        case 14:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked4);
}
export var loadAdDetails = createRequestSaga(adDetailsActions, {
  loadedSelector: adDetailsLoadedSelector,
  loadingSelector: adDetailsLoadingSelector
}, {
  forceRefresh: true
});
export function adDetailsListener() {
  return _regeneratorRuntime.wrap(function adDetailsListener$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return takeLatest(adDetailsLoad, adDetailsSaga);

        case 2:
          _context6.next = 4;
          return takeLatest(saveOfferDetails, saveOfferDetailsSaga);

        case 4:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked5);
}
/**
 * Ads request saga.
 * @type {createRequestSaga~requestSaga}
 */

export var loadAdPhotos = createRequestSaga(adPhotosActions, {
  loadedSelector: adPhotosLoadedSelector,
  loadingSelector: adPhotosLoadingSelector
}, {
  forceRefresh: true
});
export function adPhotosSaga() {
  var activeAccountId;
  return _regeneratorRuntime.wrap(function adPhotosSaga$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return select(activeAccountIdSelector);

        case 2:
          activeAccountId = _context7.sent;
          _context7.next = 5;
          return put(api.get(accountAdPhotosActions, withNativeMicroserviceUrl("/account-photo-gallery/account/".concat(activeAccountId))));

        case 5:
          _context7.next = 7;
          return put(api.get(adPhotosActions, withNativeMicroserviceUrl('/photo-gallery')));

        case 7:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked6);
}
export function accountAdPhotoUploadSaga(_ref3) {
  var image, tempId, activeAccountId, imageBlob, body;
  return _regeneratorRuntime.wrap(function accountAdPhotoUploadSaga$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          image = _ref3.payload;
          tempId = generateGuid();
          _context8.next = 4;
          return select(activeAccountIdSelector);

        case 4:
          activeAccountId = _context8.sent;
          imageBlob = dataURItoBlob(image.imageUrl);
          body = new FormData();
          body.append('image', imageBlob);
          body.append('description', image.description);
          _context8.next = 11;
          return put(api.post(accountAdPhotoUploadActions, withNativeMicroserviceUrl("/account-photo-gallery/account/".concat(activeAccountId)), {
            body: body,
            headers: {
              'Content-Type': undefined
            }
          }, {
            request: function request() {
              return _objectSpread(_objectSpread({}, image), {}, {
                galleryPhotoId: tempId
              });
            },
            success: function success(data) {
              return _objectSpread(_objectSpread({}, data), {}, {
                tempId: tempId
              });
            },
            failure: function failure(error) {
              return _objectSpread(_objectSpread({}, error), {}, {
                tempId: tempId
              });
            }
          }));

        case 11:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked7);
}
export function accountAdPhotoDeleteSaga(_ref4) {
  var payload, activeAccountId;
  return _regeneratorRuntime.wrap(function accountAdPhotoDeleteSaga$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          payload = _ref4.payload;
          _context9.next = 3;
          return select(activeAccountIdSelector);

        case 3:
          activeAccountId = _context9.sent;
          _context9.next = 6;
          return put(api.delete(accountAdPhotoDeleteActions, withNativeMicroserviceUrl("/account-photo-gallery/account/".concat(activeAccountId, "/").concat(payload)), {}, {
            request: function request() {
              return {
                galleryPhotoId: payload
              };
            }
          }));

        case 6:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked8);
}
export function adPhotosListener() {
  return _regeneratorRuntime.wrap(function adPhotosListener$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return takeLatest(adPhotosLoad, adPhotosSaga);

        case 2:
          _context10.next = 4;
          return takeLatest(accountAdPhotoUpload, accountAdPhotoUploadSaga);

        case 4:
          _context10.next = 6;
          return takeLatest(accountAdPhotoDeleteActions.load, accountAdPhotoDeleteSaga);

        case 6:
        case "end":
          return _context10.stop();
      }
    }
  }, _marked9);
}
/**
 * Ad Stats Sagas
 */

/**
 * Ad stats saga. Fetches ad stats from the API and dispatches either success or
 * failure depending on the result.
 * @return {Generator}
 */

export function adStatsSaga(_ref5) {
  var _ref5$payload, id, start, end, activeAccountId, isoStart, isoEnd;

  return _regeneratorRuntime.wrap(function adStatsSaga$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _ref5$payload = _ref5.payload, id = _ref5$payload.id, start = _ref5$payload.start, end = _ref5$payload.end;
          _context11.next = 3;
          return select(activeAccountIdSelector);

        case 3:
          activeAccountId = _context11.sent;
          isoStart = formatISO(parseDate(start));
          isoEnd = formatISO(parseDate(end));
          _context11.next = 8;
          return put(api.get(adStatsActions, withNativeMicroserviceUrl("/stats/".concat(activeAccountId, "/").concat(id, "?startDate=").concat(isoStart, "&endDate=").concat(isoEnd)), {}, {
            request: function request() {
              return {
                id: id
              };
            },
            success: function success(data) {
              return {
                data: data,
                id: id
              };
            },
            failure: function failure(error) {
              return {
                error: error,
                id: id
              };
            }
          }));

        case 8:
        case "end":
          return _context11.stop();
      }
    }
  }, _marked10);
}
export function disableAdSaga(_ref6) {
  var offerId, _yield$take, offer, activeAccountId, offersServiceUrl;

  return _regeneratorRuntime.wrap(function disableAdSaga$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          offerId = _ref6.payload;
          _context12.next = 3;
          return put(adDetailsLoad({
            offerId: offerId,
            isUniversal: false
          }));

        case 3:
          if (!true) {
            _context12.next = 16;
            break;
          }

          _context12.next = 6;
          return take(adDetailsActions.success.getType());

        case 6:
          _yield$take = _context12.sent;
          offer = _yield$take.payload;
          _context12.next = 10;
          return select(activeAccountIdSelector);

        case 10:
          activeAccountId = _context12.sent;
          offersServiceUrl = withAudienceMicroserviceUrl("/outputs/".concat(activeAccountId));
          _context12.next = 14;
          return put(api.post(adDisableActions, offersServiceUrl, {
            body: _objectSpread(_objectSpread({}, offer), {}, {
              status: 'completed',
              runUntil: parseDate().toISOString()
            })
          }));

        case 14:
          _context12.next = 3;
          break;

        case 16:
        case "end":
          return _context12.stop();
      }
    }
  }, _marked11);
}
export function adStatsListener() {
  return _regeneratorRuntime.wrap(function adStatsListener$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return takeLatest(adStatsActions.load, adStatsSaga);

        case 2:
        case "end":
          return _context13.stop();
      }
    }
  }, _marked12);
}
export var loadAdStats = createRequestSaga(adStatsActions, {
  loadedSelector: adStatsLoadedSelector,
  loadingSelector: adStatsLoadingSelector
});
/**
 * Universal Offers List Sagas
 */

/**
 * Ads request saga.
 * @type {createRequestSaga~requestSaga}
 */

export var loadUniversalOffers = createRequestSaga(universalOffersActions, {
  loadedSelector: universalOffersListIsLoadedSelector,
  loadingSelector: universalOffersListIsLoadingSelector
}, {
  forceRefresh: true
});
/**
 * Ads saga. Fetches ads from the API and dispatches either success or
 * failure depending on the result.
 * @return {Generator}
 */

export function universalOffersSaga() {
  var activeAccountId;
  return _regeneratorRuntime.wrap(function universalOffersSaga$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return select(activeAccountIdSelector);

        case 2:
          activeAccountId = _context14.sent;
          _context14.next = 5;
          return put(api.get(universalOffersActions, withNativeMicroserviceUrl("/global-offers/".concat(activeAccountId)), {}, {
            success: endDateDataReducer
          }));

        case 5:
        case "end":
          return _context14.stop();
      }
    }
  }, _marked13);
}
export function disableUniversalOfferSage(_ref7) {
  var offerId, _yield$take2, offer, activeAccountId, offersServiceUrl;

  return _regeneratorRuntime.wrap(function disableUniversalOfferSage$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          offerId = _ref7.payload;
          _context15.next = 3;
          return put(adDetailsLoad({
            offerId: offerId,
            isUniversal: true
          }));

        case 3:
          if (!true) {
            _context15.next = 16;
            break;
          }

          _context15.next = 6;
          return take(adDetailsActions.success.getType());

        case 6:
          _yield$take2 = _context15.sent;
          offer = _yield$take2.payload;
          _context15.next = 10;
          return select(activeAccountIdSelector);

        case 10:
          activeAccountId = _context15.sent;
          offersServiceUrl = withNativeMicroserviceUrl("/global-offers/".concat(activeAccountId));
          _context15.next = 14;
          return put(api.post(universalOfferDisableActions, offersServiceUrl, {
            body: _objectSpread(_objectSpread({}, offer), {}, {
              status: 'completed',
              runUntil: parseDate().toISOString()
            })
          }));

        case 14:
          _context15.next = 3;
          break;

        case 16:
        case "end":
          return _context15.stop();
      }
    }
  }, _marked14);
}
/**
 * Ads listener saga.
 * @return {Generator}
 */

export function universalOffersListener() {
  return _regeneratorRuntime.wrap(function universalOffersListener$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          _context17.next = 2;
          return takeLatest(universalOffersLoad.getType(), universalOffersSaga);

        case 2:
          _context17.next = 4;
          return takeLatest(universalOfferDisableLoad.getType(), disableUniversalOfferSage);

        case 4:
          _context17.next = 6;
          return takeLatest(universalOfferDisableSuccess.getType(), /*#__PURE__*/_regeneratorRuntime.mark(function disableUniversalOfferSuccess() {
            return _regeneratorRuntime.wrap(function disableUniversalOfferSuccess$(_context16) {
              while (1) {
                switch (_context16.prev = _context16.next) {
                  case 0:
                    _context16.next = 2;
                    return put(universalOffersLoad());

                  case 2:
                  case "end":
                    return _context16.stop();
                }
              }
            }, disableUniversalOfferSuccess);
          }));

        case 6:
        case "end":
          return _context17.stop();
      }
    }
  }, _marked15);
}